import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

function bindAction(dispatch) {
  return {
    update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
    updateEdit: (key, value) => dispatch(updateEditData(key, value)),
    updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
  };
}
const mapStateToProps = state => ({
  data: state.formDataReducer,
  filterdata: state.formDataReducer.filterdata,
  editformdata: state.formDataReducer.editformdata,
  hasErrored: state.formDataReducer.hasErrored,
  isLoading: state.formDataReducer.isLoading
});

class Checkbox extends React.PureComponent {
  constructor() {
    super()

    this.state = {
      displayValue: false
    }
  }
  componentDidMount() {
    const { control, formid, data } = this.props;

    var _data = data[formid] ? data[formid][control.key] : null
    if (control.customvalue === 'yes' && control.Truevalue) {
      if (_data == control.Truevalue) {
        this.setState({ displayValue: true });
      } else {
        this.setState({ displayValue: false });
      }
    } else {
      this.setState({ displayValue: _data });
    }
    this.controlVaildationCheck(this.props);
  }
  componentWillReceiveProps(nextProps) {
    var nextData = nextProps.data[nextProps.formid];
    var currData = this.props.data[this.props.formid];
    if (nextData && currData && nextData[nextProps.control.key] != currData[this.props.control.key]) {
      this.controlVaildationCheck(nextProps);
    }
  }

  onValueChange(value, control, action) {
    
    this.setState({ displayValue: value });
    if (control.customvalue === 'yes' && control.Truevalue) {
      if (value) {
        value = control.Truevalue;
      } else {
        value = control.Falsevalue;
      }
    }
    this.props.update(control.key, value, this.props.formid)

  }
  controlVaildationCheck(props) {
    const { control, formid, data } = props;
    if (control.require) {
      var _data = data[formid] ? data[formid][control.key] : null
      var validation = ControlService().validate(control, _data);
      if (validation) {
        if (_data === false) {
          this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
        } else {
          this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
        }
      } else {
        this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
      }
    }
  }
  render() {
    const { control, action } = this.props;

      return (
        <div className="form-group">
          {control.imageurl && <img src={control.imageurl} alt={control.label} width="100" height="100" className="mb-2 img-fluid" />}
          <label className="switch">
            {control.label && 
              <span className='pr-3'>{control.label}</span>
            }
            <span className='d-flex'>
              <input aria-label={control.label} type="checkbox" onChange={(e) => this.onValueChange(e.target.checked, control, action)}
                checked={this.state.displayValue}
                value={this.state.displayValue}
                disabled={this.props.disabled} />
              {(!control.hideswitchtext) &&
                <i className="switch-icon" data-swchon-text="Yes" data-swchoff-text="No"></i>
              }
              {control.hideswitchtext &&
                <i className="switch-icon" data-swchon-text=" " data-swchoff-text=" "></i>
              }
              
              {control.require && <sup className="text-danger font-weight-bold">*</sup>}
              {control.showhelptext &&
                <span className={"custom-tooltip"}>
                  <i className={"fa fa-question-circle ml-2 help-text"}></i>
                  <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                </span>
              }
            </span>
          </label>
          {control.description && <div className="form-text">{control.description}</div>}
        </div>
      );
  }
}

export default connect(mapStateToProps, bindAction)(Checkbox);